import { Navbar } from "@/components/Navbar";
import { SEO } from "@/components/SEO";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <SEO title="Terms of Service | A8A" description="Read the A8A terms of service governing use of our business diagnostic platform, account registration, and data handling." />
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-16">
        <h1 className="font-heading text-3xl font-medium tracking-tight text-foreground">Terms of Service</h1>
        <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted-foreground mt-2">Beta draft &middot; last updated 2026</p>

        <div className="mt-8 space-y-7 text-sm text-muted-foreground leading-relaxed">
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">1. About A8A</h2>
            <p>A8A is a free business diagnostic tool currently in beta. It is provided to help you identify possible areas of revenue, cash, margin or operational leakage based on the information you provide.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">2. Provisional results, no guarantees</h2>
            <p>All findings and opportunities are generated using an experimental, internally-defined methodology ("A8A Opportunity Model"). Results are provisional, may be incomplete, and are not independently or externally validated. A8A does not guarantee any particular outcome, saving or improvement.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">3. Not professional advice</h2>
            <p>Nothing produced by A8A constitutes financial, legal, accounting, tax or other professional advice. You should verify any finding against your own records and consult a qualified professional before making business decisions based on it.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">4. Your account and data</h2>
            <p>You are responsible for the accuracy of the information you submit. You may request deletion of your account or business data at any time by contacting us.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">5. Acceptable use</h2>
            <p>You agree not to misuse the service, attempt to access another business's data, or submit unlawful content.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">6. Limitation of liability</h2>
            <p>A8A is provided "as is" during this beta period. To the extent permitted by law, A8A is not liable for decisions made in reliance on provisional findings.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">7. Changes</h2>
            <p>These terms may be updated as the product develops. Continued use after an update constitutes acceptance of the revised terms.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">8. Beta feedback</h2>
            <p>Because A8A is in active beta, question wording, scoring logic and recommended interventions may change between visits as we refine the underlying methodology. If a finding looks wrong or a question is unclear, we welcome feedback via the contact details below — it directly shapes what we build next.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">9. Governing law</h2>
            <p>These terms are governed by the laws of the jurisdiction in which A8A operates, without regard to conflict-of-law principles. Any dispute arising from use of the platform should first be raised with us directly so we can attempt to resolve it informally.</p>
          </section>
          <section>
            <h2 className="font-heading text-base font-medium text-foreground mb-1.5">10. Contact</h2>
            <p>Questions about these terms can be sent to the A8A team via the contact details on our website.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
